/**
 * Wrapper that triggers image preload on hover, mousedown, and focus.
 * Use around links that trigger image preload on navigation.
 */
import React from 'react';
import styled from 'styled-components';

const Zone = styled.div`
  display: ${props => props.$inline ? 'inline-block' : 'block'};
`;

const PreloadZone = ({ preload, inline, children, ...props }) => (
  <Zone
    $inline={inline}
    onMouseEnter={preload}
    onMouseDown={preload}
    onFocus={preload}
    {...props}
  >
    {children}
  </Zone>
);

export default PreloadZone;
